import { motion } from "framer-motion";
import { TEACHER_LIBRARY, OWNER_LIBRARY } from "@/data/offer";

const ease = [0.22, 1, 0.36, 1];

const seen = new Set();
const PRODUCTS = [...TEACHER_LIBRARY, ...OWNER_LIBRARY]
  .flatMap((g) => g.items)
  .filter((p) => !seen.has(p.img) && seen.add(p.img));

const COLS = 4;
const columns = Array.from({ length: COLS }, (_, c) => PRODUCTS.filter((_, i) => i % COLS === c));
const offsets = ["-mt-10", "mt-4", "-mt-16", "mt-8"];

export const HeroCollage = ({ wallY, photoY }) => (
  <div
    data-testid="hero-collage"
    className="relative mx-auto h-[520px] w-full max-w-[520px] overflow-hidden sm:h-[600px] lg:h-full lg:min-h-[640px] lg:max-w-none"
  >
    <motion.div style={{ y: wallY }} className="absolute inset-x-0 top-0 grid grid-cols-4 gap-2 px-1 sm:gap-3" aria-hidden="true">
      {columns.map((col, c) => (
        <div key={c} className={`flex flex-col gap-2 sm:gap-3 ${offsets[c]}`}>
          {col.map((p, i) => (
            <motion.div
              key={p.img}
              initial={{ opacity: 0, y: 24, scale: 0.92 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 0.9, ease, delay: 0.35 + c * 0.08 + i * 0.07 }}
              className="aspect-square p-0.5 sm:p-1"
            >
              <img src={p.img} alt="" className="h-full w-full object-contain mix-blend-multiply" loading="eager" />
            </motion.div>
          ))}
        </div>
      ))}
    </motion.div>

    <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-alabaster to-transparent" aria-hidden="true" />

    <motion.img
      style={{ y: photoY, x: "-50%" }}
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2, ease, delay: 0.6 }}
      src="/photos/luiza-cutout.png"
      alt="Luiza Wójtowicz-Waga, trenerka nauczycieli i metodyczka, w czerwonej koszuli, otoczona okładkami kursów i e-booków"
      width="605"
      height="1400"
      className="absolute bottom-0 left-1/2 h-[96%] w-auto object-contain drop-shadow-[0_30px_40px_rgba(11,16,29,0.35)]"
      loading="eager"
      fetchPriority="high"
    />
  </div>
);
